/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { SimulationChannelStateEnum } from "./SimulationChannelStateEnum";
import {
  SimulationChannelStateEnumFromJSON,
  SimulationChannelStateEnumFromJSONTyped,
  SimulationChannelStateEnumToJSON,
  SimulationChannelStateEnumToJSONTyped,
} from "./SimulationChannelStateEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface SimulationChannel
 */
export interface SimulationChannel {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  readonly channelName?: string;
  /**
   *
   */
  readonly created?: Date;
  /**
   *
   */
  readonly state?: SimulationChannelStateEnum;
}

/**
 * Check if a given object implements the SimulationChannel interface.
 */
export function instanceOfSimulationChannel(value: object): value is SimulationChannel {
  return true;
}

export function SimulationChannelFromJSON(json: any): SimulationChannel {
  return SimulationChannelFromJSONTyped(json, false);
}

export function SimulationChannelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationChannel {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    channelName: json["channel_name"] == null ? undefined : json["channel_name"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    state: json["state"] == null ? undefined : SimulationChannelStateEnumFromJSON(json["state"]),
  };
}

export function SimulationChannelToJSON(json: any): SimulationChannel {
  return SimulationChannelToJSONTyped(json, false);
}

export function SimulationChannelToJSONTyped(
  value?: Omit<SimulationChannel, "id" | "simulation" | "channelName" | "created" | "state"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
